import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isLoading", "isError", "children", "Content", "contentProps", "ErrorContent", "errorContentProps", "widths", "heights", "style", "className"];
/* hs-eslint ignored failing-rules */

import styled from 'styled-components';
import SkeletonBase, { getSize } from './SkeletonBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SkeletonLoad = styled(SkeletonBase).withConfig({
  displayName: "SkeletonLoadWrapper__SkeletonLoad",
  componentId: "sc-1fbdwlb-0"
})(["height:", ";width:", ";"], ({
  height
}) => getSize(height), ({
  width
}) => getSize(width));
const SkeletonLoadWrapper = _ref => {
  let {
      isLoading,
      isError,
      children = null,
      Content,
      contentProps,
      ErrorContent,
      errorContentProps,
      widths = [],
      heights = [],
      style,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (isError && ErrorContent) {
    return /*#__PURE__*/_jsx(ErrorContent, Object.assign({}, errorContentProps));
  }
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      style: style,
      className: className,
      children: widths.map((width, index) => {
        return /*#__PURE__*/_jsx(SkeletonLoad, Object.assign({
          className: index ? 'm-top-1' : undefined,
          height: heights[index],
          width: width,
          use: "on-shade"
        }, rest), index);
      })
    });
  }
  if (Content) {
    return /*#__PURE__*/_jsx(Content, Object.assign({}, contentProps));
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default SkeletonLoadWrapper;